"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const modelConfig_1 = require("./modelConfig");
const chalk = require("chalk");
let strategies = {};
function initialize() {
    //TODO: ideally read in from json file and be different per strategy
    strategies['a'] = new StrategyA(new modelConfig_1.ModelConfig(5, .35, .5, 365, 1.5));
    strategies['aa'] = new StrategyAA(new modelConfig_1.ModelConfig(5, .35, .5, 365, 1));
    strategies['b'] = new StrategyB(new modelConfig_1.ModelConfig(5, .35, .5, 365, .5));
    strategies['c'] = new StrategyC(new modelConfig_1.ModelConfig(5, .35, .5, 365, .5));
    strategies['d'] = new StrategyD(new modelConfig_1.ModelConfig(5, .35, .5, 365, .5));
    strategies['realtime'] = new StrategyRealtime(new modelConfig_1.ModelConfig(5, .35, .5, 3560, .5));
}
exports.initialize = initialize;
function getStrategy(name) {
    if (strategies[name] == null) {
        console.log(chalk.red('Unknown strategy name %s. Default to strategy a\n'), name);
        name = 'a';
    }
    return strategies[name];
}
exports.getStrategy = getStrategy;
class BaseStrategy {
    constructor(config) {
        this.config = config;
    }
}
exports.BaseStrategy = BaseStrategy;
class StrategyA extends BaseStrategy {
    constructor(config) {
        super(config);
        this.description = "Growth in first 200 days then coast at 10% UA levels";
    }
    generatePaidUsers(day) {
        if (day <= 200) {
            return 1000;
        }
        return 100;
    }
    generateOrganics(day, paidUsers) {
        return paidUsers * this.config.kfactor;
    }
}
class StrategyAA extends StrategyA {
    constructor(config) {
        super(config);
        this.description = "Growth in first 200 days then coast at 50% UA levels";
    }
    generatePaidUsers(day) {
        if (day <= 200) {
            return 1000;
        }
        return 500;
    }
    generateOrganics(day, paidUsers) {
        return paidUsers * this.config.kfactor;
    }
}
class StrategyB extends BaseStrategy {
    generatePaidUsers(day) {
        return Math.max(100 - day, 20);
    }
    generateOrganics(day, paidUsers) {
        return paidUsers * this.config.kfactor;
    }
}
class StrategyC extends BaseStrategy {
    generatePaidUsers(day) {
        if (day > 150) {
            return Math.max(Math.abs(150 - day), day);
        }
        return Math.pow(day, 2);
    }
    generateOrganics(day, paidUsers) {
        return paidUsers * this.config.kfactor;
    }
}
class StrategyD extends BaseStrategy {
    generatePaidUsers(day) {
        if (day < 75) {
            return 100000;
        }
        return 1000;
    }
    generateOrganics(day, paidUsers) {
        return paidUsers * this.config.kfactor;
    }
}
class StrategyRealtime extends BaseStrategy {
    generatePaidUsers(day) {
        return Math.round(this.config.dailySpend / this.config.cpi);
    }
    generateOrganics(day, paidUsers) {
        return paidUsers * this.config.kfactor;
    }
}



// WEBPACK FOOTER //
// ./src/strategies.js